export default "__VITE_ASSET__C2PfLA1y__"